export class FetchSavedCardsAction {
  static readonly type = '[OrderAccount] Fetch saved cards for the current user'
}
